import { useTranslation } from "react-i18next";
import { FaStar } from "react-icons/fa6";
import { HiOutlineHeart } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { appRoutesObj } from "src/app.paths";

interface IProps {
  id: number;
  schoolName: string;
  schoolDescription: string;
  rating: number;
  imageUrl: string;
}

function SchoolCardComponent(props: IProps) {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  return (
    <div
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      onClick={() =>
        navigate(appRoutesObj.getSchoolDetailsPageUrl(props.id.toString()))
      }
      className="w-[343px] h-[332px] drop-shadow-md bg-zinc-50 rounded-xl relative cursor-pointer"
    >
      {/* Add to faviorate */}
      <HiOutlineHeart
        className={`${
          i18n.language === "ar" ? "right-0 mr-6" : "left-0 ml-6"
        } absolute top-0 mt-6 mobile:left-0 text-2xl text-zinc-50 cursor-pointer`}
      />
      {/* Rating */}
      <div
        className={`${
          i18n.language === "ar" ? "left-0 ml-6" : "right-0 mr-6"
        } absolute flex flex-row-reverse gap-2 justify-center items-center top-0 w-20 h-8 rounded-lg bg-zinc-500 bg-opacity-50 mt-6 backdrop-blur-md`}
      >
        <FaStar className="text-2xl text-amber cursor-pointer" />
        <p className="text-sm text-zinc-50 font-medium">{props.rating}</p>
      </div>
      <img
        alt=""
        className="w-[343px] h-[196px] object-cover rounded-t-xl"
        src={props.imageUrl}
      />
      <div className="flex flex-col items-start justify-center mx-4 mt-2 gap-1">
        <p className="font-arBold text-xl text-zinc-700">{props.schoolName}</p>
        <p className="font-ar text-base text-zinc-700">
          {props.schoolDescription}
        </p>
      </div>
    </div>
  );
}

export default SchoolCardComponent;
